export class DateTimeHelpers {
	static formatTime(date) {
		const dateFormat = new Date(date);
		return dateFormat.toISOString().replace(/-|:|\.\d+/g, '');
	}

	static calculateDuration(start, end) {
		start = new Date(start);
		end = new Date(end);
		const eventDuration = ((end.getTime() - start.getTime()) / 60 * 1000);

		// We need to convert the duration from minutes to hh:mm
		const hourDuration = eventDuration < 600 ?
			'0' + Math.floor((eventDuration / 60)) :
			Math.floor((eventDuration / 60)) + '';

		const minuteDuration = eventDuration % 60 < 10 ?
			'0' + eventDuration % 60 :
			eventDuration % 60 + '';

		return (hourDuration + minuteDuration);
	}
}
